/**************************************************************************************************************************************************
*   MODULE NAME     :  Search
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  15-02-2021
*   DESCRIPTION     :  Component to load Search Results
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2517014
*   DESCRIPTION: <GLSD>: Layer7 API Deprecation
*   removed unused/commented code 
*   DATE: 28-Feb-2025
/**************************************************************************************************************************************************/
import React from "react";
import { Container, Row, Col, Form, OverlayTrigger, Button, Popover, } from "react-bootstrap";
import { FaSpinner, FaExclamationTriangle, FaTimes, FaFile, FaHashtag, FaPaperclip } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import DataTable from '../common/dataTable/DataTable';
import { loadAllAbstracts, loadAllAbstractsPagination, saveAllAbstractsCriteria } from "../../actions/searchActions";
import { loadAllAlerts } from "../../actions/abstractActions";
import { } from '../common/MessagesPool';
import "../search/SearchRes.css";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import Select from "react-select";
import { ListGroup } from "react-bootstrap";
import { exportPDF } from "../common/ExportToPDF";

class SearchResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      cols: [
        { label: "Original Title", value: "originalTitle" }, { label: "No. of case IDS", value: "caseIds" },
        { label: "Date Record Received", value: "dateRecordReceived" }, { label: "Date Article Received", value: "dateArticleReceived" },
        { label: "Date Translation Received", value: "dateTranslationReceived" }, { label: "Date Closed", value: "dateClosed" }, { label: "Lock By Date", value: "lockByDate" }],
      colSelected: ["originalTitle", "caseIds", "dateClosed", "dateArticleReceived", "dateRecordReceived", "dateTranslationReceived", "lockByDate"],
      showAbstract: false,
      searchCriteriaObject: {},
      masterData: this.props.masterData,
      loadResults: false,
      showDatatable: false,
      allAbstracts: false,
      selected: [],
      authors: '',
      title: '',
      paginationData: {
        searchText: "",
        startFrom: 0,
        perPageLimit: 5,
        sortField: "title",
        sortOrder: "asc",
        count: 0,
        page: 1,
        searchCount: 0,
      },
      filterAbstractDataList: [
      ],
      addAbstractModalFlag: false,
      action: null,
      rowData: null,
      alertMasterData: null,
      colsList: [
        { label: "Original Title", value: "originalTitle" }, { label: "No. of case IDS", value: "caseIds" },
        { label: "Date Record Received", value: "dateRecordReceived" }, { label: "Date Article Received", value: "dateArticleReceived" },
        { label: "Date Translation Received", value: "dateTranslationReceived" }, { label: "Date Closed", value: "dateClosed" },
        { label: "Date Record Reviewed", value: "dateAbstractReviewed" }, { label: "Date Article Ordered", value: "dateArticleOrdered" },
        { label: "Date Article Ordered2", value: "dateArticleOrdered2" }, { label: "Date Translation Requested", value: "dateTranslationRequested" },
        { label: "Date Article Reviewed", value: "dateArticleReviewed" }, { label: "Date Abstract Valid", value: "dateAbstractValid" },
        { label: "Date Article Valid", value: "dateArticleValid" }, { label: "Date Translation Valid", value: "dateTranslationValid" },
        { label: "Date Follow-up Received", value: "dateFlwUpReceived" }, { label: "Lock By Date", value: "lockByDate" },],
    }
    this.loadAllAbstracts = this.loadAbstractsData.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  /**
   * Function to hide/show loader.
   * @param isLoading whether to hide or show loader
   */
  setLoader = isLoading => this.setState({ isLoading });

  /**
   * Function to initiate life cycle hooks.
   */
  componentDidMount() {
    this.loadAlertsData();
  }

  loadData = ({
    searchText,
    sortField,
    sortOrder,
    filters,
    page,
    sizePerPage,
  }) => {
    const startFrom = (page - 1) * sizePerPage;
    let paginationData = {
      searchText: (searchText === undefined ? '' : searchText),
      startFrom,
      perPageLimit: sizePerPage,
      sortField,
      sortOrder,
      page,
    };
    
    if((searchText != this.state.paginationData.searchText)) {
      paginationData.page = 1;
      paginationData.startFrom = 0;
    }
    this.setState({ paginationData }, this.loadAllAbstracts);
  };

  loadAlertsData = async () => {
    this.setLoader(true)
    let response = await this.props.loadAllAlerts();
    let alertMasterData = {};
    if (response && response.data && response.data.result) {
      response.data.result.map((e) => {
        alertMasterData[e.masterDataKey] = e.masterDataValue
      })
      this.setState(prevState => ({
        alertMasterData: alertMasterData

      })
      )
    }
    this.setLoader(false)
  }
  /**
   * compare Dates
   */
  compareDate(_date, _days) {
    var date_C = new Date(_date);
    date_C.setDate(date_C.getDate() + _days);
    return (date_C <= new Date());
  }
  async generateAlert(abstract) {
    let alertFlag = false;
    let alertTitle = "";
    if (this.state.alertMasterData === null) { await this.loadAlertsData(); }

    const { alertMasterData } = this.state;
    if (abstract.migrateFlag === false) {
      if (!abstract["dateAbstractReviewed"]) {
        alertFlag = this.compareDate(abstract["dateRecordReceived"], parseInt(alertMasterData["ALERT_DAYS_ABST_NOT_REVD"]))
        alertTitle = "Abstract Not Reviewed"
      }
      else if (abstract["dateTranslationRequested"] && (!abstract["dateTranslationReceived"])) {
        alertFlag = this.compareDate(abstract["dateTranslationRequested"], parseInt(alertMasterData["ALERT_DAYS_ART_NOT_RECVD"]))
        alertTitle = "Translation Not Returned"

      }
      else if (abstract["dateArticleOrdered"] && (!abstract["dateArticleReceived"])) {
        alertFlag = this.compareDate(abstract["dateArticleOrdered"], parseInt(alertMasterData["ALERT_DAYS_ART_NOT_REVD"]))
        alertTitle = "Article Not Received"

      }
      else if (abstract["dateArticleReceived"] && (!abstract["dateArticleReviewed"])) {
        alertFlag = this.compareDate(abstract["dateArticleReceived"], parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"]))
        alertTitle = "Article Not Reviewed"

      }
      else if (abstract["dateTranslationReceived"] && (!abstract["dateArticleReviewed"])) {
        alertFlag = this.compareDate(abstract["dateTranslationReceived"], parseInt(alertMasterData["ALERT_DAYS_TRANS_NOT_RET"]))
        alertTitle = "Article Not Reviewed"

      }
      else {
        alertFlag = false;
      }
    }
    return alertFlag;
  }
  /**
   * process attributes 
   * @param {*} results 
   */
  async addAlert(results) {
    results = results.map(async (abstract) => {
      abstract["alert"] = await this.generateAlert(abstract);
      return abstract;


    });
    return results;
  }
  /**
   * Function to  loadAbstractsData by page
   */
  loadAbstractsData = async () => {
    this.setLoader(true);
    const { paginationData, searchCriteriaObject, colSelected } = this.state;
    let res = await this.props.loadAllAbstractsPagination(searchCriteriaObject, paginationData, colSelected);
    if (res && res.data && res.data.result) {
      const { count, searchCount } = res.data.result;
      paginationData.count = count;
      paginationData.searchCount = searchCount;
      let abstracts = res.data.result.list
      await this.addAlert(res.data.result.list);
      this.setState({
        filterAbstractDataList: abstracts,
        paginationData: paginationData,
      }
      );
    }

    this.setLoader(false);
  }

  /**
   * load all abstracts
   */
  loadAllAbstractsButton = async () => {
    const { searchCriteriaObject } = this.state;
    this.setLoader(true)
    let res = await this.props.saveAllAbstractsCriteria(searchCriteriaObject);
    if (res && res.data && res.data.result && res.data.result[0] && res.data.result[0].searchId) {
      let id = res.data.result[0].searchId;
      window.open(`/searchResult/${id}`, "", `width=${window.innerWidth},height=${window.innerHeight}`);
    }
    this.setLoader(false)
  }

  openAbstractDetailScreen = (abstractId) => {
    window.open(`/abstractDetail/${abstractId}`, "", `width=${window.innerWidth},height=${window.innerHeight}`);
  }
  onHandleSelectChange = (selectedOption, name) => {
    this.setState({
      cols: selectedOption,
      colSelected: selectedOption ? selectedOption.map((e) => e.value) : [],
    }, () => {

    });
  }



  componentWillReceiveProps(nextProps) {
    this.setState({
      searchCriteriaObject: nextProps.searchCriteriaObject,
      loadResults: nextProps.loadResults,
      masterData: nextProps.masterData,
      allAbstracts: false,
      showDatatable: false,
    }, () => {
      if (nextProps.loadResults) {
        this.setState({
          showDatatable: true

        })
      }
    });
  }
  exportPDF(_headers, _data, _criteria) {
    _criteria = _criteria.slice(0, _criteria.length - 2)
    _criteria = _criteria + "\n\n"
    const { colSelected, filterAbstractDataList } = this.state;
    let colSelectedHead = [...colSelected];
    var headers = [["Alert", "Title", "Author", "Product", "Status"]];
    var widths = [20, 185, 105, 50, 50]
    colSelectedHead.slice(0, 6).forEach(_key => {
      _key = _key.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
          .replace('-', '')
          .replace('_', '');
      });
      _key = _key.replace(/([A-Z])/g, " $1");
      _key = _key.charAt(0).toUpperCase() + _key.slice(1);

      headers[0].push(_key);
      widths.push(50)
    })
    filterAbstractDataList.sort((a, b) => (a.title > b.title) ? 1 : -1)

    const data = filterAbstractDataList.map(elt => {
      let element;
      let alert = "";
      alert = alert + (elt.migrateFlag == true ?
        "#" : "");
      alert = alert + (elt.active === false ? "X" : "");
      alert = alert + (elt.active === true && elt.enblAlrtsAndVldtinsFlag == true ? "!" : "");
      if (elt.product && elt["productId"])
        element = [alert, elt.title, elt.authors, elt["product"]["masterDataValue"], elt["status"]["masterDataValue"]];
      else if (elt.status && elt["statusId"])
        element = [alert, elt.title, elt.authors, elt["product"], elt["status"]["masterDataValue"]];
      else {
        element = [alert, elt.title, elt.authors, elt["product"], elt["status"]];

      }
      colSelected.slice(0, 6).forEach(ele => {
        let dt = (ele.includes("date") || ele.includes("Date")) && elt[ele] ? ddmmmyyyyFormat(elt[ele]) : (elt[ele] ? elt[ele] : "");
        if (ele.includes("caseId")) {
          dt = elt[ele] ? (elt[ele].match(/,/g) || []).length + 1 : ""
        }
        element.push(dt)
      })
      return element;
    }
    )
    let titlepdf = this.state.saveTitle ? "Saved Search Title : " + this.state.saveTitle : " ";
    exportPDF("Search Results", titlepdf, headers, data, widths, "Criteria - " + _criteria)
  }


  render() {
    const { isLoading, cols, masterData, searchCriteriaObject, showDatatable, colsList, colSelected, showAbstract, allAbstracts, filterAbstractDataList, loadResults,
      paginationData: { page, count, searchCount, sortOrder, sortField }
    } = this.state;
    var criteriaStr = "";
    const abstractDataColumns = [
      {
        dataField: "abstractId",
        text: "Abstract",
        hidden: true,
      },
      {
        dataField: 'alert',
        text: 'Alert',
        csvExport: false,
        headerClasses: "width-5",
        headerStyle: (colum, colIndex) => {
          return { width: '5vw' };
        },
        formatter: (cellContent, row) => {
          return <span style={{ display: 'inline-block', position: 'relative' }}>
            {row && (row.migrateFlag == true)
              && <FaHashtag style={{ color: 'gray' }} />}
            {row && row.active === false && <FaTimes style={{ color: 'red' }} />}
            {row && row.alert && row.active === true && row.enblAlrtsAndVldtinsFlag == true && <FaExclamationTriangle style={{ color: 'orange' }} />}
 </span>;

        }
      },
      {
        dataField: 'title',
        text: 'Title',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '26vw' };
        },
        style: { textAlign: "left" },
        headerClasses: "width-250",
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false
                  }
                }
              }}
              overlay={
                <Popover style={{ maxWidth: "50vw" }} id="popover-basic">
                   <Popover.Content>{row.title}</Popover.Content>
                </Popover>}
            >
              <span className="fake-link"
                style={{ textAlign: "left" }} onClick={() => this.openAbstractDetailScreen(row.abstractId)}>{row.title && row.title.length <= 145 ? row.title : row.title && row.title.substr(0, 145) + "..."}</span>

            </OverlayTrigger>
          );
          return row.title ? _popOver : "";
        },

      },
      {
        dataField: 'originalTitle',
        text: 'Original Title',
        hidden: !colSelected.includes("originalTitle"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '11vw' };
        },
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false
                  }
                }
              }}
              overlay={
                <Popover style={{ maxWidth: "50vw" }} id="popover-basic">
                  <Popover.Content>{row.originalTitle}</Popover.Content>
                </Popover>}
            >
              <div>{(row && row.originalTitle) ? (row.originalTitle.length <= 25 ? row.originalTitle : row.originalTitle.substr(0, 25) + "...") : " "}</div>
            </OverlayTrigger>
          );
          return row && row.originalTitle ? _popOver : "";
        },
      },
      {
        dataField: 'authors',
        text: 'Author(s)',
        headerClasses: "width-20",
         sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '11vw', textAlign: 'center', textTransform: 'none' };
        },
        style: { textAlign: "left" },

        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false
                  }
                }
              }}
              overlay={
                <Popover style={{ maxWidth: "40vw" }} id="popover-contained">
                   <Popover.Content>{row.authors}</Popover.Content>
                </Popover>}
            >
              <div>{row.authors&& row.authors.length <= 25 ? row.authors : row.authors && row.authors.substr(0, 25) + "..."}</div>
            </OverlayTrigger>
          );
          return row.authors ? _popOver : "";
        },
      },
      {
        dataField: 'product.masterDataValue',
        text: 'Product',
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        sort: true,
        csvFormatter: (cellContent, row) => {
          return row.product && row.product.masterDataValue ? row.product.masterDataValue : "";
        }
      },
      {
        dataField: 'status.masterDataValue',
        text: 'Status',
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        headerClasses: "width-10",
        style: { textAlign: "left" },
        sort: true,
        csvFormatter: (cellContent, row) => {
          return row.status && row.status.masterDataValue ? row.status.masterDataValue : "";
        }
      },
      {
        dataField: 'casesIds',
        text: 'No. of  Cases IDs',
        hidden: !colSelected.includes("caseIds"),
        headerStyle: (colum, colIndex) => {
          return { width: '5vw' };
        },
        formatter: (cellContent, row) => {
          return row.caseIds ? (row.caseIds.match(/,/g) || []).length + 1 : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.caseIds ? (row.caseIds.match(/,/g) || []).length + 1 : "";
        }
      },
      {
        dataField: 'dateRecordReceived',
        text: 'Date Record Received',
        hidden: !colSelected.includes("dateRecordReceived"),

        style: { textAlign: "left" },
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        sort: true,
         formatter: (cellContent, row) => {
          return row.dateRecordReceived ? ddmmmyyyyFormat(row.dateRecordReceived) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateRecordReceived ? row.dateRecordReceived : "";
        },

      },
      {
        dataField: 'dateArticleReceived',
        text: 'Date Article Received',
        hidden: !colSelected.includes("dateArticleReceived"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateArticleReceived ? ddmmmyyyyFormat(row.dateArticleReceived) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateArticleReceived ? (row.dateArticleReceived) : "";
        },
      },
      {
        dataField: 'dateTranslationReceived',
        text: 'Date Translation Received',
        hidden: !colSelected.includes("dateTranslationReceived"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateTranslationReceived ? ddmmmyyyyFormat(row.dateTranslationReceived) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateTranslationReceived ? (row.dateTranslationReceived) : "";
        },

      },
      {
        dataField: 'dateClosed',
        text: 'Date Closed',
        hidden: !colSelected.includes("dateClosed"),
        sort: true,
        style: { textAlign: "left" },

        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateClosed ? ddmmmyyyyFormat(row.dateClosed) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateClosed ? (row.dateClosed) : "";
        },
      },
      {
        dataField: 'dateAbstractReviewed',
        text: 'Date Record Reviewed',
        hidden: !colSelected.includes("dateAbstractReviewed"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateAbstractReviewed ? ddmmmyyyyFormat(row.dateAbstractReviewed) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateAbstractReviewed ? (row.dateAbstractReviewed) : "";
        },

      },
      {
        dataField: 'dateArticleOrdered',
        text: 'Date Article Ordered',
        hidden: !colSelected.includes("dateArticleOrdered"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateArticleOrdered ? ddmmmyyyyFormat(row.dateArticleOrdered) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateArticleOrdered ? (row.dateArticleOrdered) : "";
        },

      },
      {
        dataField: 'dateArticleOrdered2',
        text: 'Date Article Ordered2',
        hidden: !colSelected.includes("dateArticleOrdered2"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateArticleOrdered2 ? ddmmmyyyyFormat(row.dateArticleOrdered2) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateArticleOrdered2 ? (row.dateArticleOrdered2) : "";
        },
      },
      {
        dataField: 'dateTranslationRequested',
        text: 'Date Translation Requested',
        hidden: !colSelected.includes("dateTranslationRequested"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateTranslationRequested ? ddmmmyyyyFormat(row.dateTranslationRequested) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateTranslationRequested ? (row.dateTranslationRequested) : "";
        },
      },
      {
        dataField: 'dateArticleReviewed',
        text: 'Date Article Reviewed',
        hidden: !colSelected.includes("dateArticleReviewed"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateArticleReviewed ? ddmmmyyyyFormat(row.dateArticleReviewed) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateArticleReviewed ? (row.dateArticleReviewed) : "";
        },
      },
      {
        dataField: 'dateAbstractValid',
        text: 'Date Abstract Valid',
        hidden: !colSelected.includes("dateAbstractValid"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateAbstractValid ? ddmmmyyyyFormat(row.dateAbstractValid) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateAbstractValid ? (row.dateAbstractValid) : "";
        },
      },
      {
        dataField: 'dateArticleValid',
        text: 'Date Article Valid',
        hidden: !colSelected.includes("dateArticleValid"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateArticleValid ? ddmmmyyyyFormat(row.dateArticleValid) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateArticleValid ? (row.dateArticleValid) : "";
        },
      },
      {
        dataField: 'dateTranslationValid',
        text: 'Date Translation Valid',
        hidden: !colSelected.includes("dateTranslationValid"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateTranslationValid ? ddmmmyyyyFormat(row.dateTranslationValid) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateTranslationValid ? (row.dateTranslationValid) : "";
        },
      },
      {
        dataField: 'dateFlwUpReceived',
        text: 'Date Follow-up Received',
        hidden: !colSelected.includes("dateFlwUpReceived"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.dateFlwUpReceived ? ddmmmyyyyFormat(row.dateFlwUpReceived) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.dateFlwUpReceived ? (row.dateFlwUpReceived) : "";
        },
      },
      {
        dataField: 'lockByDate',
        text: 'Lock By Date',
        hidden: !colSelected.includes("lockByDate"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '9vw' };
        },
        formatter: (cellContent, row) => {
          return row.lockByDate ? ddmmmyyyyFormat(row.lockByDate) : "";
        },
        csvFormatter: (cellContent, row) => {
          return row.lockByDate ? (row.lockByDate) : "";
        },
      },


    ];
    return (
      <>
        <div className="abstractWrap">
          <Container fluid>
            <div className=" headerpart">
              <h1 className="pl-0 ml-n2">Search Results</h1>
            </div>
            <i style={{color: 'red'}}>Note: Please apply selection criteria to filter the records before navigating to the search results screen by clicking Show All Abstracts.</i>
            {loadResults && <div className="mb-0 ml-n2 saveTitlecss">
              Criteria :
            </div>}
            <ListGroup className="ml-n2 criteriacss" horizontal>
              {Object.keys(searchCriteriaObject).filter(
                (key) => ((searchCriteriaObject[key]  && searchCriteriaObject[key].toString().trim()!=='')|| key.includes("include")))
                .map(function (key) {
                  let val = searchCriteriaObject[key];
                  let _key = key;
                  try {
                    _key = _key.replace(/([-_][a-z])/ig, ($1) => {
                      return $1.toUpperCase()
                        .replace('-', '')
                        .replace('_', '');
                    });
                    _key = _key.replace(/([A-Z])/g, " $1");
                    _key = _key.charAt(0).toUpperCase() + _key.slice(1);

                    if (key.includes("include")) {
                      val = val === 0 ? "False" : "True";
                    }
                    else if (key.includes("date")) {
                      let fromTo = val;
                      let val1 = fromTo["from"] ? ` From ( ${new Date(fromTo["from"]).toISOString().substr(0, 10)} )` : "";
                      let val2 = fromTo["to"] ? ` To ( ${new Date(fromTo["to"]).toISOString().substr(0, 10)} )` : "";
                      val = val1 + val2;
                    }
                    else if (["statusId", "explanationId", "product", "country"].some(el => key.includes(el))) {
                      _key = key.substr(0, key.length - 2);
                      _key = _key.replace(/([A-Z])/g, " $1");
                      _key = _key.charAt(0).toUpperCase() + _key.slice(1);

                      val = masterData[key.substr(0, key.length - 2) + "List"].filter((e) => val.toString().includes(e.value));
                      let str = ""
                      val.map((e) => { str = str + e.label + ", "; })
                      val = str.slice(0, -2)
                    }
                    else if (["caseManager"].some(el => key.includes(el))) {
                      switch (key) {
                        case "caseManagerId1":
                          _key = "Abstract Record Screener"
                          break;
                        case "caseManagerId2":
                          _key = "Full Text Screener"
                          break;
                        case "caseManagerId3":
                          _key = "Record Closer"
                          break;
                        default:
                          _key = "Case Manager"
                          break;

                      }
                      val = masterData["userList"].filter((e) => e.value.includes(val));
                      val = val[0].label;
                    }
                  }
                  catch (e) {
                    console.log(e);
                    _key = "";
                    val = "";
                  }
                  criteriaStr = criteriaStr + `${_key}  :  ${val}` + " ; "
                  return <ListGroup.Item className="py-1 px-1">{`${_key}  :  ${val}`}</ListGroup.Item>
                })}

            </ListGroup>
            <br></br><br></br>
            {loadResults && <Row className="mgBottom">
              <Form.Group controlId="cols">
                <Form.Label> Select columns to display :
                    </Form.Label>
                <Select
                  isMulti
                  name="cols"
                  placeholder="Select columns"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  menuPortalTarget={document.body}
                  options={colsList}
                  value={cols}
                  maxMenuHeight={130}
                  onChange={selectedOption =>
                    this.onHandleSelectChange(selectedOption, "cols")}
                />
              </Form.Group>

            </Row>
            }
            <br></br> <br></br>
            <div className="filter-action-section">

              <Row>
                
                <Col sm={12} className="btns mb-0">
                <div className="float-right form-inline">
                    <div className='mr-3'>
                      {loadResults && <Button
                        variant="primary"
                        className="addBtn"
                        onClick={() =>
                          this.loadAllAbstractsButton(true)
                        }
                      >
                        Show All Abstracts
                    </Button>
                      }
                      </div>
                    <div className="mr-3">
                      {loadResults && <Button
                        variant="primary"
                        className="addBtn"
                        onClick={() => { this.exportPDF([], filterAbstractDataList, criteriaStr) }}
                      >
                        Print Results
                    </Button>}
                    </div>
                </div>
                </Col>
              </Row>
            </div>

            <div className="leftAbstractList screenWidthfix">
              {!loadResults && <div className=" headerpart">
                <h3>Please enter Search Criteria</h3>
              </div>
              }
              {
                showDatatable &&
                <DataTable
                  loadData={this.loadData}
                  totalSize={count}
                  searchCount={searchCount}
                  page={page}
                  sizePerPage={[25, 30, 50, 75, 100, 150]}
                  remote
                  message={true}
                  sortOrder={sortOrder}
                  keyField="id"
                  defaultSortField={sortField}
                  data={filterAbstractDataList}
                  columns={abstractDataColumns}
                />}

            </div>
          </Container>
        </div>
        {isLoading && (
          <div className="loader">
            <FaSpinner />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    abstractDataList: state.homeDataReducer && state.homeDataReducer.data && state.homeDataReducer.data.data
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadAllAbstractsPagination,
      loadAllAbstracts,
      loadAllAlerts,
      saveAllAbstractsCriteria
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchResults));